import { render, staticRenderFns } from "./registrationResult.vue?vue&type=template&id=357b27c4&scoped=true"
import script from "./registrationResult.vue?vue&type=script&lang=js"
export * from "./registrationResult.vue?vue&type=script&lang=js"
import style0 from "./registrationResult.vue?vue&type=style&index=0&id=357b27c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357b27c4",
  null
  
)

export default component.exports